import * as React from "react";
import "../../style/fonts.css";
import "./enterPass.css";
import CtaButton from "../ctaButton/ctaButton";
import Input from "../input/input";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import translate from "../../translations/i18n";
import hidden_pass from "../../icons/hidden.svg";
import visible_pass from "../../icons/visible.svg";
import {
  reauthenticateUser,
  deleteAcc,
  resetDeleteVars,
} from "../../store/actions/deleteAction";

//TODO: ADD STRING - ENTER PASSWORD

export interface Props {
  passwordError: any;
  reauthenticateUser(password): void;
  deleteAcc(): void;
  resetDeleteVars(): void;
  reauthenticateUserComp: any;
  deleteUserCompleted: any;
}

interface State {
  password: string;
  seePassword: boolean;
}

class EnterPassScr extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { password: "", seePassword: false };

    this.reAuthenticate = this.reAuthenticate.bind(this);
  }

  handleChangePass(event) {
    this.setState({ password: event.target.value });
  }

  showEye() {
    if (this.state.seePassword) return <img src={hidden_pass} />;
    else return <img src={visible_pass} />;
  }

  passSeen() {
    this.setState((prevState) => ({
      seePassword: !prevState.seePassword,
    }));
  }

  async reAuthenticate() {
    try {
      await this.props.reauthenticateUser(this.state.password);
    } catch (e) {
      console.log(e)
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.reauthenticateUserComp === true &&
      this.props.reauthenticateUserComp != prevProps.reauthenticateUserComp
    ) {
      this.props.deleteAcc();
    }
  }

  render() {
    if (this.props.deleteUserCompleted === true) {
      this.props.resetDeleteVars();
      return <Redirect to="/appHome" push />;
    }
    return (
      <div className="ENTER_PASS_CONT">
        <div className="ENTER_PASS_TITLE">
          <div className="TITLE_2">ENTER PASSWORD</div>
        </div>
        <div className="ENTER_PASSWORD_INPUT_CONT">
          <Input
            type={"password"}
            placeholder={translate("PASSWORD_FORM")}
            value={this.state.password}
            onChange={this.handleChangePass.bind(this)}
            warning={
              this.props.passwordError ? this.props.passwordError.code : null
            }
            passwordSeen={this.state.seePassword}
          />
          <div className="PASS_ICON" onClick={this.passSeen.bind(this)}>
            {this.showEye()}
          </div>
        </div>
        <div className="ENTER_PASS_BTN_CONT" onClick={this.reAuthenticate}>
          <CtaButton width={"280px"} text={"SEND"} color={"white"} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    passwordError: state.del.reauthenticateError,
    reauthenticateUserComp: state.del.reauthenticateUserComp,
    deleteUserCompleted: state.del.deleteUserCompleted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reauthenticateUser: (password) => dispatch(reauthenticateUser(password)),
    deleteAcc: () => dispatch(deleteAcc()),
    resetDeleteVars: () => dispatch(resetDeleteVars()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterPassScr);



// WEBPACK FOOTER //
// ./src/components/screens/enterPass.tsx